import { render, staticRenderFns } from "./VuesticProfileCard.vue?vue&type=template&id=534b7dba&"
import script from "./VuesticProfileCard.vue?vue&type=script&lang=js&"
export * from "./VuesticProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./VuesticProfileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticProfileCard.vue"
export default component.exports